import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { connectState } from '@examdojo/angular/util';
import { PageType, TopicStatusIconComponent } from '@examdojo/category/v2';
import { TopicLevel2BadgeComponent } from '@examdojo/topics-tree';
import { TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs';

const DISPLAYED_PAGE_TYPES: PageType[] = ['concept', 'insights'];

@Component({
  selector: 'exam-topic-status-badge',
  imports: [TopicStatusIconComponent, TranslocoPipe],
  template: `
    @if (state.topicLevel2TabsStatuses; as topicLevel2TabsStatuses) {
      @for (tab of topicLevel2TabsStatuses; track tab.type) {
        <dojo-topic-status-icon
          class="mr-1"
          [status]="tab.status"
          [tooltip]="'examdojo.learn_hub.topic_tabs.' + tab.type | transloco"
        ></dojo-topic-status-icon>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopicStatusBadgeComponent extends TopicLevel2BadgeComponent {
  private readonly topicLevel2TabsStatuses$ = toObservable(this.topic).pipe(
    map((item) =>
      item.latest_pages
        .filter(({ page_type }) => DISPLAYED_PAGE_TYPES.includes(page_type))
        .map((page) => ({ status: page.page_status, type: page.page_type })),
    ),
  );

  readonly state = connectState({
    topicLevel2TabsStatuses: this.topicLevel2TabsStatuses$,
  });
}
